import { page } from "$app/stores"
import { derived } from "svelte/store"

export const isActive = derived([page], ([currentPage]) => {
    return (str: string) => currentPage.url.pathname.startsWith(str)
})

export const isPage = derived([page], ([currentPage]) => {
    return (str: string) => currentPage.route.id == str
})

export const inPage = derived([page], ([currentPage]) => {
    return (str: string) => currentPage.route.id?.startsWith(str)
})
